import { Autocomplete, Box, createFilterOptions, TextField } from "@mui/material";
import { useState } from "react";

const ProductBarcodeAuto = ({ selected, setProd, getdataforbar, options }) => {

    console.log("frombarcdoe:" + JSON.stringify(options));
    return <div style={{ marginLeft: "3px" }
    }>
        <Autocomplete
            value={selected}
            options={options}
            onInputChange={getdataforbar}
            onChange={(e, value) => {
                console.log(value.prod_code);
                setProd(value);
            }}

            // filterOptions={filterOptions}
            getOptionLabel={option => option.prod_code}
            renderOption={(props, option) => (<Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>

                {option.prod_code} {option.prod_name}
            </Box>)
            }
            renderInput={(params) => (

                <TextField  {...params} label="Баркод" variant="outlined" />

            )} />
    </div >
}

export default ProductBarcodeAuto